"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getRequestWithBoundHeaders;

var _superagent = _interopRequireDefault(require("superagent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// withCredentials - CORS request using credentials with cookie-auth
function getRequestWithBoundHeaders(settee) {
  return {
    get: function get(url) {
      return (0, _superagent["default"])('GET', url).withCredentials().set(settee);
    },
    post: function post(url) {
      return (0, _superagent["default"])('POST', url).withCredentials().set(settee);
    },
    put: function put(url) {
      return (0, _superagent["default"])('PUT', url).withCredentials().set(settee);
    },
    patch: function patch(url) {
      return (0, _superagent["default"])('PATCH', url).withCredentials().set(settee);
    },
    head: function head(url) {
      return (0, _superagent["default"])('HEAD', url).withCredentials().set(settee);
    },
    del: function del(url) {
      return (0, _superagent["default"])('DELETE', url).withCredentials().set(settee);
    },
    request: function request(method, url) {
      return (0, _superagent["default"])(method, url).withCredentials().set(settee);
    }
  };
}